// utils/getPlaceholder.ts
export const getPlaceholder = (i18n: string, count: number | undefined) => {
  const records = count ?? 0;

  switch (i18n) {
    case 'fr':
      return `recherche à partir de ${records} enregistrements`;
    case 'ro':
      return `cauta din ${records} inregistrari`;
    case 'zh':
      return `从 ${records} 条记录中搜索`;
    case 'ar':
      return 'بحث في السجلات...';
    case 'hindi':
      return `${records} रिकॉर्ड खोजें...`;
    default:
      return `Search ${records} records...`;
  }
};
